import PropTypes from 'prop-types';
import { ColorOption, ColorSelect } from './Style';
import { useColorList } from '../../hooks/useColorList';

const SelectColor = ({ value, onChange, disabled }) => {
  const { colorList, getColorById } = useColorList();

  const onChangevalue = (selectedValue) => {
    onChange(selectedValue);
  };

  return (
    <>
      <div>
        <ColorSelect
          defaultValue={value}
          onChange={onChangevalue}
          variant={getColorById(value, null)}
          disabled={disabled}
        >
          {colorList.map((color) => (
            <ColorOption
              key={color.id}
              variant={color.color}
              style={{ background: color.color, color: 'transparent' }}
              value={color.id}
            >
              <span style={{ color: 'transparent' }}>{color.color}</span>
            </ColorOption>
          ))}
        </ColorSelect>
      </div>
    </>
  );
};

SelectColor.propTypes = {
  value: PropTypes.number,
  onChange: PropTypes.func,
  disabled: PropTypes.bool,
};

export default SelectColor;
